import React from "react";
import css from "./freetrail.module.css";
import { FaPlay, FaCheckCircle } from "react-icons/fa";

const FreeTrailCard = () => {
  return (
    <div className={css.wrapper}>
      <div className={css.text}>
        <h4>Let's Try! Get Free Support</h4>
        <h2>Start Your 14-Day Free Trial</h2>
        <p>
          We can help you to create your dream website for better business
          revenue.
        </p>
      </div>

      <div className={css.btns}>
        <button className={css.request}>Request for Demo</button>
        <button className={css.watch}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <FaPlay className={css.play} />
            Watch Demo
          </div>
        </button>
      </div>

      <ul className={css.list}>
        <li>
            <FaCheckCircle />
            <span>Free 14-day trial</span>
        </li>
        <li>
            <FaCheckCircle />
            <span>No credit card required</span>
        </li>
        <li>
            <FaCheckCircle />
            <span>Support 24/7</span>
          
        </li>
        <li>
            <FaCheckCircle />
            <span>Cancel anytime</span>
        </li>
      </ul>

      <div className={css.top_circle}></div>
      <div className={css.bottom_circle}></div>
    </div>
  );
};

export default FreeTrailCard;
